import React from "react";
import "../assets/styles/teamCard.scss";

// "MS. KERZIAH SHARON ADJAGRAH" -> "KA" (ignores titles like Ms., Mrs., Mr., Dr.)
function getInitials(name = "") {
  const words = name
    .replace(/\b(mr|mrs|ms|miss|dr|prof)\.?\s/gi, "")
    .split(/[\s-]+/)
    .filter((w) => /[a-z]/i.test(w));
  if (!words.length) return "?";
  const first = words[0][0];
  const last = words.length > 1 ? words[words.length - 1][0] : "";
  return (first + last).toUpperCase();
}

const Card = ({ backgroundImage, title, description }) => {
  return (
    <article className="Teamcard">
      <div className="photo">
        {backgroundImage ? (
          <img src={backgroundImage} alt={title} loading="lazy" />
        ) : (
          <div className="placeholder" aria-hidden="true">
            <span>{getInitials(title)}</span>
          </div>
        )}
      </div>

      <div className="content">
        <h2>{title}</h2>
        <p>{description}</p>
      </div>
    </article>
  );
};

export default Card;